/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { Button, TermsConditionsText, Text } from "UpduoLibrary";
import { skaleTextGray, skaleCommunityGray } from "config/UpduoColors";

const textColor = skaleTextGray;

export default function Auth0View({ onAuth0Press }) {
  const startObject = useSelector((state: RootState) => state.startObject);

  return (
    <View
      style={{
        marginBottom: 15,
        alignItems: "center",
      }}
    >
      <Text
        style={{
          color: skaleCommunityGray,
          fontSize: 30,
          fontWeight: "bold",
          marginBottom: 15,
          textAlign: "center",
        }}
      >
        {`You will enter your\nemail and login for:\n${startObject?.name}`}
      </Text>
      <Text
        style={{
          color: textColor,
          fontSize: 16,
          textAlign: "center",
        }}
      >
        {`This was given to you when you first joined ${startObject?.name}.\nDo not create a new account.`}
      </Text>
      <TermsConditionsText />
      <Button onPress={() => onAuth0Press()} text={"Continue"} marginTop={20} />
    </View>
  );
}
